import { getCurrentBrand } from '@/utils/getCurrentBrand';
import { getCookie } from 'cookies-next';
import { decodeJwt } from 'jose';
import { AlltIdJwtToken } from 'lib/alltIdMyData';
import Script from 'next/script';
import { useEffectOnce } from 'react-use';
import { AnalyticsConfig } from './types';

interface CtsProps {
  ctsData: Record<string, string> | undefined;
  allerGaData: Record<string, string> | undefined;
  ctsConfig: AnalyticsConfig;
}

const CTS_SCRIPT_URL = `//cdn.aller.se/cts/v1.12.49/se-ocelot/bundle.js`;

export const Cts: React.FC<CtsProps> = ({ ctsData, allerGaData, ctsConfig }) => {
  useEffectOnce(() => {
    (async () => {
      const token = await getCookie('login_token');

      const payload = (token ? decodeJwt(token) : {}) as AlltIdJwtToken;

      const userTags = payload?.data?.user?.tags || [];
      const { slug } = getCurrentBrand();
      const isUserSubscribed = userTags.includes(`subscription_${slug}`);

      window.cts = {
        metadata: {
          ...ctsData,
          user_paywall_access: isUserSubscribed,
        },
        config: {
          ...ctsConfig,
          debug: new URL(window.location.href).searchParams.has('debug'),
        },
      };

      window.aller_ga = {
        ...allerGaData,
        affiliateBool: allerGaData?.containAffiliate || false,
        isAffiliate: allerGaData?.containAffiliate || false,
      };

      if (typeof window.cts.start === 'function') {
        window.cts.start();
      }
    })();
  });

  return <Script id="cts-tracking" src={CTS_SCRIPT_URL} strategy="afterInteractive" />;
};
